<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Transfer car to other Users</p>
                <button class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <user-select></user-select>
                <div class="notification">
                    <strong>Please add some text here regarding the invoice cancellation!</strong>
                    adipiscing elit lorem ipsum dolor. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum <a>felis venenatis</a> efficitur. Sit amet,
                    consectetur adipiscing elit
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" :class="{'is-loading' : isLoading}" @click="transferCar">Transfer Car</button>
                <button class="button" @click="closeModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import UserSelect from '../Cars/Car/Details/TransferCar/Inputs/UserSelect.vue'
    import apiCars from '../../api/apiCars'
    import apiFavorites from "../../api/apiFavorites";
    export default {
        components: {
            UserSelect
        },
        props: ['car'],
        data() {
            return {
                isLoading: false,
            }
        },
        computed: {
            isActive() {
                return this.$store.getters.getFavoriteCarTransferModalStatus(this.car.lot_id)
            }
        },
        methods: {
            closeModal() {
                this.$store.dispatch('setSingleCarTransferModalStatus', false)
            },
            transferCar() {
                this.isLoading = true
                let data = {
                    id: this.car.lot_id,
                    query: {
                        user_id: this.$store.getters.getSingleCarTransferUserId['id']
                    }
                }
                apiFavorites
                    .transferCar(data)
                    .then((response) => {
                        this.closeModal()
                        this.$store.dispatch('setSingleCarTransferUserId', null)
                        location.reload()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>
    .modal-card-body {
        min-height: 200px;
    }
    .notification {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Favorites/TransferFavoriteModal.vue